var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3843 0.420112L4.82123 3.59824C-1.60708 5.74877 -1.60708 9.25529 4.82123 11.3952L7.65942 12.3381L8.60196 15.1772C10.7412 21.6076 14.2572 21.6076 16.3964 15.1772L19.5841 5.62164C21.0032 1.33117 18.6733 -1.01004 14.3843 0.420112ZM14.7231 6.11955L10.6988 10.1664C10.54 10.3253 10.3388 10.3994 10.1375 10.3994C9.93633 10.3994 9.73512 10.3253 9.57626 10.1664C9.26915 9.85914 9.26915 9.35064 9.57626 9.04342L13.6006 4.99661C13.9077 4.68939 14.416 4.68939 14.7231 4.99661C15.0303 5.30383 15.0303 5.81233 14.7231 6.11955Z",
    fill: "#475467"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnShare);
export default __webpack_public_path__ + "static/media/unShare.45016af52e0201dae8fbb598a56965e3.svg";
export { ForwardRef as ReactComponent };